module.exports = __webpack_public_path__ + "media/images/icons/hand-thumbs-up-fill-74d978c256b74d66552ceb8258de80af.png";